import { z } from 'zod';

export const testInboxMessageSummarySchema = z.object({
  id: z.string(),
  to: z.string(),
  channel: z.string(),
  subject: z.string().nullable(),
  fromName: z.string().nullable(),
  fromEmail: z.string().nullable(),
  eventType: z.string().optional(),
  notificationId: z.string().optional(),
  createdAt: z.string(),
});
export type TestInboxMessageSummary = z.infer<typeof testInboxMessageSummarySchema>;

export const testInboxMessageDetailSchema = testInboxMessageSummarySchema.extend({
  bodyHtml: z.string().nullable(),
  bodyText: z.string().nullable(),
  replyTo: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
});
export type TestInboxMessageDetail = z.infer<typeof testInboxMessageDetailSchema>;

export const testInboxDeleteResultSchema = z.object({
  deleted: z.number(),
});
export type TestInboxDeleteResult = z.infer<typeof testInboxDeleteResultSchema>;
